import { render, staticRenderFns } from "./HrPerfPromiseDetail.vue?vue&type=template&id=ba6ae75c&scoped=true&"
import script from "./HrPerfPromiseDetail.vue?vue&type=script&lang=js&"
export * from "./HrPerfPromiseDetail.vue?vue&type=script&lang=js&"
import style0 from "./HrPerfPromiseDetail.vue?vue&type=style&index=0&id=ba6ae75c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba6ae75c",
  null
  
)

export default component.exports